import {IAccountOperationsState, initialAccountOperationsState} from "../../state/accounting/accounting.state";
import {AccountOperationsActions, EAccountOperationActions} from "../../actions/accounting/account-operations.actions";


export const accountOperationsReducers = (
  state = initialAccountOperationsState,
  action: AccountOperationsActions
):IAccountOperationsState =>{
  switch (action.type) {
    case EAccountOperationActions.GetAccountOperations:
      return {
        ...state
      };
    case EAccountOperationActions.GetAccountOperationsSuccess:
      return {
        ...state,
        data: action.payload,
        isLoaded: true
      };
    case EAccountOperationActions.GetAccountOperationsFailure:
      return {
        ...state,
        data: [],
        isLoaded: false
      };
    case EAccountOperationActions.ClearAccountOperations:
      return {
        ...state,
        data: [],
        isLoaded: false
      };
    default:
      return state;
  }
};

